/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
import PropTypes from 'prop-types';
import {
  React, useEffect, useContext,
} from 'react';
// eslint-disable-next-line import/no-named-default
import { useProject } from '../../../config/ProjectContext';
import {
  DEPLOY_TYPE_REGEX,
} from '../../../utils/constants';
import CustomTextArea from '../../utils/CustomTextArea';
import StagedDeploymentConfig from './StagedDeploymentConfig';
import SelectedObjectsToDeployContext from '../../../config/SelectedAssetsContext';



export default function RegexDeploy({
  setTargets, setType, values, setValues, regex, setRegex, stagedDeployment, setStagedDeployment, onStagedConfigChange, onLoadingChange,
}) {
  const { project } = useProject();
  const { selectedObjectsToDeploy } = useContext(SelectedObjectsToDeployContext);

  // DATA RETRIEVAL __________________________
  async function loadType() {
    setType(DEPLOY_TYPE_REGEX);
  }

  // WEBPAGE______________________________

  useEffect(() => {
    loadType();
  }, [project]);

  useEffect(() => {
    if (regex.length > 0) {
      const regexList = [];
      regexList.push(regex);
      setTargets(regexList);
    }
  }, [regex]);

  return (
    <div className="bg-gray-50 w-full max-w-full">
      <div className="bg-white rounded-xl w-full max-w-full">
        <div className="p-3 sm:p-6">
          <CustomTextArea
            screenId="inputDeploymentRegex"
            title="Regular expression"
            placeHolder="Regex"
            size={300}
            values={regex}
            setValues={setRegex}
            isComment={false}
            rows={4}
          />
        </div>
        
        <div className="flex justify-end py-4 px-3 sm:px-6">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={stagedDeployment}
              onChange={(e) => setStagedDeployment(e.target.checked)}
              disabled={!regex || regex.length === 0}
              className="mr-2"
            />
            Staged Deployment
          </label>
        </div>

        <StagedDeploymentConfig
          isEnabled={stagedDeployment}
          deploymentType={DEPLOY_TYPE_REGEX}
          regex={regex}
          selectedObjectsToDeploy={selectedObjectsToDeploy}
          onConfigChange={onStagedConfigChange}
          isBundleDeployment={selectedObjectsToDeploy?.[0]?.type === 'bundle'}
          onLoadingChange={onLoadingChange}
        />

        <div className="flex flex-col items-center pb-6">
          <div className="w-full">
            <CustomTextArea
              screenId="inputDeploymentComments-regexDeployment"
              title="Deployment description"
              placeHolder="Comments (optional)"
              size={300}
              values={values}
              setValues={setValues}
              isComment
              rows={4}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

RegexDeploy.propTypes = {
  setTargets: PropTypes.func.isRequired,
  setType: PropTypes.func.isRequired,
  values: PropTypes.string.isRequired,
  setValues: PropTypes.func.isRequired,
  regex: PropTypes.string.isRequired,
  setRegex: PropTypes.func.isRequired,
  stagedDeployment: PropTypes.bool.isRequired,
  setStagedDeployment: PropTypes.func.isRequired,
  onStagedConfigChange: PropTypes.func,
  onLoadingChange: PropTypes.func,
};

RegexDeploy.defaultProps = {
  onStagedConfigChange: () => {},
  onLoadingChange: () => {},
};
